/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CatalogItemFacts} from "./catalogItemFacts.zod";
import {Currency} from "./currency.zod";
import {CustomerOfferConfirmedChapter} from "./customerOfferConfirmedChapter.zod";
import {Language} from "./language.zod";
import {Money} from "./money.zod";
import {OfferContent} from "./offerContent.zod";
import {ResolvedOfferVariable} from "./resolvedOfferVariable.zod";

export const prepareCustomerOfferSendResultMutationVersionRegExp = new RegExp("^(0|[1-9][0-9]*)$");

export const PrepareCustomerOfferSendResult = zod
  .object({
    customerOfferId: zod.uuid(),
    documentSource: zod.literal("LIVE"),
    mutationVersion: zod.string().regex(prepareCustomerOfferSendResultMutationVersionRegExp),
    confirmationToken: zod.string().min(1),
    language: Language,
    currency: Currency,
    content: OfferContent,
    catalogItems: zod.array(CatalogItemFacts),
    chapters: zod.array(CustomerOfferConfirmedChapter),
    variables: zod.array(ResolvedOfferVariable),
    totalValue: Money,
  })
  .describe(
    "Current commercial confirmation, including optional Chapter quotes, resolved text and ordinary selling total. Contains no coefficient or protected cost\/benefit breakdown. Confirmation binds these terms and mutation\/stage identity; unchanged commercial terms may use freshly captured internal facts at Send. No early frozen or issued document.",
  );

export type PrepareCustomerOfferSendResult = zod.input<typeof PrepareCustomerOfferSendResult>;
export type PrepareCustomerOfferSendResultOutput = zod.output<
  typeof PrepareCustomerOfferSendResult
>;
